<template>
	<TypographyTitle :level="2" class="align-center">
		{{ $t('tariffs.header') }}
	</TypographyTitle>

	<TypographyParagraph class="align-center">
		{{ $t('tariffs.description') }}
	</TypographyParagraph>

	<div class="wrapper">
		<Card v-for="tariff in tariffs" :key="tariff.id" class="tariff-card">
			<TypographyTitle :level="2" class="align-center">{{ tariff.title }}</TypographyTitle>
			<div class="align-center tinted">{{ tariff.description }}</div>
			<div class="align-center">
				<span class="price">{{ toRubles(tariff.price_per_day) }}</span> {{ $t('tariffs.pricePerDayText', toRubles(tariff.price_per_day)) }}
			</div>
			<Button
				v-if="allowChangeTariff"
				class="select-rovers-button"
				type="default"
				size="large"
				block
				@click="onApplyTariff(tariff.id)"
			>
				{{ $t(hasRovers ? 'tariffs.applyTariffButtonLabel' : 'tariffs.connectRoverButtonLabel') }}
			</Button>
			<TariffFeature :enabled="tariff.high_accuracy" name="high_accuracy" />
			<TariffFeature :enabled="tariff.rapid_convergence" name="rapid_convergence" />
		</Card>
	</div>
	<ApplyTariffToListModal v-if="selectedTariff != null" v-model="applyTariffModalVisible" :tariff="selectedTariff" />
</template>

<script>
import { ref, computed, onMounted } from 'vue';
import { TypographyTitle, TypographyParagraph, Card, Button } from 'ant-design-vue';

import { useRouter } from 'vue-router';

import TariffFeature from '@/components/tariffs/TariffFeature';
import ApplyTariffToListModal from '@/components/tariffs/ApplyTariffToListModal';

import { useRoversStore } from '@/stores/rovers';
import { useUserStore } from '@/stores/user';

import Api from '@/api/Api';
import Utils from '@/api/Utils';

export default {
	components: {
		TypographyTitle, TypographyParagraph, Card, Button,
		TariffFeature, ApplyTariffToListModal,
	},
	setup() {
		const tariffs = ref([]);
		const userStore = useUserStore();
		const roversStore = useRoversStore();
		const hasRovers = computed(() => roversStore.rovers.length > 0);
		onMounted(() => {
			Api.tariffGetList(response => tariffs.value = response.tariffs);
			if (userStore.isAuthenticated) {
				roversStore.updateRoversList();
			}
		});

		const router = useRouter();
		const applyTariffModalVisible = ref(false);
		const selectedTariff = ref(null);
		const onApplyTariff = id => {
			if (!userStore.isAuthenticated) {
				userStore.redirectToLogin();
			} else if (!hasRovers.value) {
				router.push({ name: 'add-rover' });
			} else {
				applyTariffModalVisible.value = true;
				selectedTariff.value = tariffs.value.find(tariff => tariff.id === id);
			}
		};

		const maxWidth = computed(() => (tariffs.value.length * 400) + 'px');
		return {
			tariffs,
			hasRovers,
			applyTariffModalVisible,
			selectedTariff,
			maxWidth,
			allowChangeTariff: userStore.allowChangeTariff,

			onApplyTariff,
			toRubles: Utils.toRubles,
		};
	}
}
</script>

<style scoped>
.wrapper {
	width: 100%;
	max-width: v-bind(maxWidth);
	margin: 24px auto 50px auto;
	display: grid;
	grid-auto-columns: minmax(min-content, 1fr);
	grid-auto-flow: column;
	gap: 16px;
}

@media screen and (max-width: 767px) {
	.wrapper {
		grid-auto-flow: row;
	}
}

.tariff-card {
	border-radius: 10px;
	box-shadow: 0px 20px 40px 0px #25292e3d;
}

.price {
	font-size: 3rem;
}

.select-rovers-button {
	margin-top: 8px;
	margin-bottom: 16px;
}
</style>